<template>
    <Page>
        <ImageAndText 
            animation="zoom"
            src="/CaseStudy/bridgette-noun.jpg"
            floor-shadow
            border>

            <h2 class="text-[150px] text-white/20 leading-5 -ml-4">“</h2>
            <p class="text-sm xl:text-base 2xl:text-xl font-normal text-white/80 pl-2">
                Connected Vehicles Carbucks PROTECT has had an immediate impact on our dealership. 
                Our sales team love the product as it's a 'no-brainer' addition for every new car. 
                And customers love it too, as it gives them peace of mind knowing their wear-and-tear 
                costs are covered. This product helps us differentiate our offer and will help 
                improve long-term customer retention.
            </p>

            <p class="text-sm xl:text-base 2xl:text-xl font-semibold text-cyan-400 pl-2 mt-3">
                We forecast the product to increase our top-line revenue by nearly a million dollars and bottom-line profit margin of nearly $500,000.            
            </p>

            <h1 class="mt-6 3xl:mt-10">Bridgette Noun</h1>
            <h2 class="text-white/60">General Manager, Suttons Chullora</h2>
        </ImageAndText>
    </Page>
</template>